import { RoutePath } from "../lib/enums";

const NotFound = () => {
  return (
    <div>
      <div style={{margin: '60px 0 40px 0'}}>
        <h1>Sidan du vill nå kan inte hittas</h1>
      </div>
      <p
        className="text-large"
        style={{
          marginTop: '20px',
          marginBottom: '40px',
        }}>
        Kontrollera att du skrivit in rätt webbadress. Du kan också prova att söka i sökrutan eller gå till{' '}
        <a href={RoutePath.HomePage}>startsidan</a> för att hitta informationen du behöver
      </p>
    </div>
  );
};

export default NotFound;
